import { Button } from "primereact/button";

import { buttonDelete, formDeleteAccount, buttonAnnul } from "_constants";

export const FooterDeleteAccount = ({
  handleDismiss,
}: {
  handleDismiss: () => void;
}) => {
  return (
    <div className="flex-container justify-between align-center">
      <Button
        className="width-50"
        label={buttonDelete}
        severity="danger"
        form={formDeleteAccount}
      />
      <Button
        className="width-50"
        type="button"
        onClick={handleDismiss}
        text
        label={buttonAnnul}
        severity="secondary"
      />
    </div>
  );
};
